import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-page-header-title',
  template: '<ng-content />',
  styleUrls: ['page-header-title.component.scss']
})
export class PageHeaderTitleComponent {
}
